import { useState } from "react";
import {  Box,Input, Flex, RadioGroup, Radio, Stack, Button, ButtonGroup, useToast} from "@chakra-ui/react";
import { GruntComponentAction } from "../../util/grunt";

const OperaterViewData = ({GrCmpAct,operater,onCloseComponent, onSaveData, onUpdate, onDeleteData, onUpdatePwd,size='xs'}) => {
    const [newOper,setNewOper]=useState(GrCmpAct===GruntComponentAction.Create);
    const [id, setId]=useState(newOper?-1:operater.id);
    const [ime,setIme]=useState(newOper?"":operater.ime);
    const [aktivan, setAktivan] = useState(newOper?true:operater.aktivan);
    const [prezime,setPrezime]=useState(newOper?"":operater.prezime);
    const [email,setEmail]=useState(newOper?"":operater.email);
    const [usr,setUsr]=useState(newOper?"":operater.usr);
    const [pwd,setPwd]=useState(newOper?"":operater.pwd);
    const [uloga,setUloga]=useState(newOper?"r":operater.uloga);
    const [ronly,setRonly]=useState(GrCmpAct===GruntComponentAction.Read);
    const toast = useToast()
    
    let _admin=true;
//hooks
// useEffect(()=>{
//     setId(newOper?-1:operater.id);
//     setIme(newOper?"":operater.ime);
//     setPrezime(newOper?"":operater.prezime);
//     setEmail(newOper?"":operater.email);
//     setUsr(newOper?"":operater.usr);
//     setUloga(newOper?"r":operater.uloga);
//     setAktivan(newOper?true:operater.aktivan);
// },[])
//methods

const handleChange=(e)=>{
    let v=e.target.value;
    switch (e.target.id) {
        case "ime":
            setIme(v);
            break;
        case "prezime":
            setPrezime(v);
            break;
        case "email":
            setEmail(v);
            break;
        case "usr":
            setUsr(v);
            break;
        case "pwd":
            setPwd(v);
            break;
        case "rbA":
            setUloga("a");
            break;
        case "rbW":
            setUloga("w");
            break;
        case "rbR":
            setUloga("r");
            break;
        case "rbV":
            setUloga("v");
            break;
        default:
    }
    
}
const saveData=(e)=>{
    let _dataok=true;
    if (_dataok){
        if (GrCmpAct===GruntComponentAction.Create) {
            onSaveData(id,ime,prezime,email,usr,pwd,uloga);    
        } else {
            onUpdate(id,ime,prezime,email,usr,uloga);
            
        }
        
    }
    
}

const resetPassword=(e)=>{
    onUpdatePwd(id,usr);
    
    
}

const aktivirajdeaktivirajOperatera=(e)=>{
    onDeleteData(id);
}

const inputPwd=()=>{
    if (newOper) {
        return (
            <>
                <Box color={'grunt2'}>Lozinka</Box>
                <Box id="pwd"  mb='1rem' mr='1rem'>
                    <Input focusBorderColor='grunt2.400' size={size} id="pwd" fontWeight={'semibold'} variant={'filled'} key='inpPwd' isReadOnly={ronly} 
                    maxLength={20} value={pwd} type={'password'} onChange={handleChange} disabled={newOper?false:true}/>
                </Box>
            </>
        )
    }
}

//return<Box h={'100%'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} key='drzave_component' pl='1rem' pr={'0.5rem'}>
    return (
        <Flex direction={"column"}>
            <Box color={'grunt2'} fontSize={size}>Id</Box>
            <Box mb='1rem' mr='1rem'><Input focusBorderColor='grunt2.400' size={size} fontWeight={'semibold'} variant={'filled'} key='inpId' value={newOper?-1:operater.id} disabled={true}/></Box>
            <Box color={'grunt2'} fontSize={size}>Ime</Box>
            <Box mb='1rem' mr='1rem'><Input focusBorderColor='grunt2.400' size={size} id={'ime'} fontWeight={'semibold'} variant={'filled'} key='inpIme' isReadOnly={ronly} 
            maxLength={20} value={ime} onChange={handleChange}/></Box>
            <Box color={'grunt2'} fontSize={size}>Prezime</Box>
            <Box id="prezime"  mb='1rem' mr='1rem'><Input focusBorderColor='grunt2.400' size={size} id={'prezime'} fontWeight={'semibold'} variant={'filled'} 
            key='inpPrezime' isReadOnly={ronly} maxLength={40} value={prezime} onChange={handleChange}/></Box>
            <Box color={'grunt2'} fontSize={size}>Email</Box>
            <Box id="email"  mb='1rem' mr='1rem'><Input focusBorderColor='grunt2.400' size={size} id="email" type={'email'} fontWeight={'semibold'} variant={'filled'} key='inpEmail' 
            isReadOnly={ronly} maxLength={40} value={email} onChange={handleChange}/></Box>
            <Box color={'grunt2'} fontSize={size}>Korisničko ime</Box>
            <Box id="usr"  mb='1rem' mr='1rem'><Input focusBorderColor='grunt2.400' size={size} id="usr" fontWeight={'semibold'} variant={'filled'} key='inpUsr' isReadOnly={ronly} 
            maxLength={20} value={usr} onChange={handleChange}/></Box>
            {inputPwd()}
            <Box color={'grunt2'} fontSize={size}>Uloga</Box>
            <RadioGroup mb={'1rem'} variant={'filled'} color={'grunt2'}
            value={uloga} size={'sm'} fontSize={size} colorScheme='grunt2'>
                <Stack direction={'row'} spacing={'1rem'} ml='1rem'>
                <Radio id={'rbA'} value="a" isReadOnly={ronly} onChange={handleChange}>Administrator</Radio>
                <Radio id={'rbW'} value="w" isReadOnly={ronly} onChange={handleChange}>Čitanje/Pisanje</Radio>
                <Radio id={'rbR'} value="r" isReadOnly={ronly} onChange={handleChange}>Čitanje</Radio>
                </Stack>
                <Stack direction={'row'} spacing={'1rem'} ml='1rem'>
                    <Radio id={'rbV'} value="v" isReadOnly={ronly} onChange={handleChange}>Veterinar</Radio>
                </Stack>
                
            </RadioGroup>
            {
            (GrCmpAct===GruntComponentAction.Read && _admin) ?  (
                <ButtonGroup gap={'1rem'} size={size}>
                    
                    <Button colorScheme={'grunt2'} name="btnCancle" onClick={()=>onCloseComponent()} variant={'outline'}>Odustani</Button>
                </ButtonGroup>
            ) : (<></>)
            }
            {
                (GrCmpAct===GruntComponentAction.Create && _admin) ?  (
                    <ButtonGroup gap={'1rem'} size={size}>
                        <Button colorScheme={'grunt2'} name="btnSave" onClick={saveData}>Spremi</Button>
                        <Button colorScheme={'grunt2'} name="btnCancle" onClick={()=>onCloseComponent()} variant={'outline'}>Odustani</Button>
                    </ButtonGroup>
                ) : (<></>)
            }
            {
                (GrCmpAct===GruntComponentAction.Edit && _admin) ?  (
                    <Flex direction={'column'} gap='1rem'>
                    <ButtonGroup gap={'1rem'}>
                        <Button colorScheme={'grunt2'} size='xs' name="btnResetPwd" onClick={resetPassword}>Resetiraj lozinku</Button>
                        <Button colorScheme={aktivan?'red':'grunt2'} size='xs' name="btnDelUsr" variant={'outline'} onClick={aktivirajdeaktivirajOperatera}>
                            {aktivan?"Deaktiviraj operatera":"Aktiviraj operatera"}
                        </Button>
                    </ButtonGroup>
                    <ButtonGroup gap={'1rem'}>
                        <Button colorScheme={'grunt2'} size='xs' name="btnSave" onClick={saveData}>Spremi</Button>
                        <Button colorScheme={'grunt2'} size='xs' name="btnCancle" onClick={()=>onCloseComponent()} variant={'outline'}>Odustani</Button>
                    </ButtonGroup>
                    </Flex>
                ) : (<></>)
            }

            <Box/>
        </Flex>
    );
}

export default OperaterViewData;
